/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InstituteWithRole
 */
export interface InstituteWithRole {
    /**
     * 
     * @type {string}
     * @memberof InstituteWithRole
     */
    instituteWithRoleId: string;
    /**
     * 
     * @type {string}
     * @memberof InstituteWithRole
     */
    instituteName: string;
    /**
     * 
     * @type {string}
     * @memberof InstituteWithRole
     */
    instituteShortName?: string;
    /**
     * 
     * @type {string}
     * @memberof InstituteWithRole
     */
    instituteRole: string;
    /**
     * 
     * @type {boolean}
     * @memberof InstituteWithRole
     */
    official: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InstituteWithRole
     */
    pidActive?: boolean;
}

/**
 * Check if a given object implements the InstituteWithRole interface.
 */
export function instanceOfInstituteWithRole(value: object): value is InstituteWithRole {
    if (!('instituteWithRoleId' in value) || value['instituteWithRoleId'] === undefined) return false;
    if (!('instituteName' in value) || value['instituteName'] === undefined) return false;
    if (!('instituteRole' in value) || value['instituteRole'] === undefined) return false;
    if (!('official' in value) || value['official'] === undefined) return false;
    return true;
}

export function InstituteWithRoleFromJSON(json: any): InstituteWithRole {
    return InstituteWithRoleFromJSONTyped(json, false);
}

export function InstituteWithRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): InstituteWithRole {
    if (json == null) {
        return json;
    }
    return {
        
        'instituteWithRoleId': json['instituteWithRoleId'],
        'instituteName': json['instituteName'],
        'instituteShortName': json['instituteShortName'] == null ? undefined : json['instituteShortName'],
        'instituteRole': json['instituteRole'],
        'official': json['official'],
        'pidActive': json['pidActive'] == null ? undefined : json['pidActive'],
    };
}

export function InstituteWithRoleToJSON(json: any): InstituteWithRole {
    return InstituteWithRoleToJSONTyped(json, false);
}

export function InstituteWithRoleToJSONTyped(value?: InstituteWithRole | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'instituteWithRoleId': value['instituteWithRoleId'],
        'instituteName': value['instituteName'],
        'instituteShortName': value['instituteShortName'],
        'instituteRole': value['instituteRole'],
        'official': value['official'],
        'pidActive': value['pidActive'],
    };
}

